import React, { Suspense, lazy, useState, useCallback, useEffect } from "react";
import Helmet from "react-helmet";
import Link from "./LinkWithTransitionLock";
import svgPanZoom from "svg-pan-zoom";
import Hammer from "hammerjs";
import { isMobile } from "mobile-device-detect";
import {
  TimelineMax,
  TweenMax,
  TweenLite,
  Linear,
  TextPlugin,
  ThrowPropsPlugin,
  EasePack,
  CSSPlugin,
  ScrollToPlugin,
  Power1,
  Power2,
  Power3,
  Power4,
  Expo,
  gsap,
} from "gsap";

import coupon from "../images/coupon.jpg";

class Page extends React.Component {
  constructor(props) {
    super(props);
  }

  // static contextType = VideoIsPlayedContext;

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <>
        <section className="coupon section_container sticky">
          <div className="inner_content">
            <div className="row_area_m">
              <div className="col_1">
                <div className="col_box col_sticky">
                  <h3 className="section_main_title">
                    集點活動
                    <br />
                    <div className="en">Rewards Program</div>
                  </h3>
                </div>
              </div>
              <div className="col_2">
                <article className="inner_article">
                  <p>
                    2021/5/17-9/15期間，國家人權博物館結合綠島在地店家，共同推出《綠島人權藝術季－集點送好禮》活動！只要到本活動合作店家消費即可集點，集滿5點即可持集點卡至人權館商品店兌換禮品！
                  </p>
                  <h4>(一) 集點步驟</h4>
                  <ol>
                    <li>至綠島人權藝術季合作店家消費，即可獲得一個點數</li>
                    <li>集滿5點（店家不可重複）＋綠島人權藝術季FB專頁按讚</li>
                    <li>
                      帶著集點卡至人權館綠島園區商品店兌換禮品（一人限換一份）
                    </li>
                  </ol>
                  <h4>(二) 注意事項</h4>
                  <ol>
                    <li>
                      本活動將以波段方式贈送禮品：人權藝術季T恤＞好物套裝組（環保杯套＋零錢包＋便利貼＋復刻筆記本)＞環保餐具組＞馬克杯＞天光筆記本＞貴賓筆＞L夾（5入一組）。
                    </li>
                    <li>
                      各波段禮品贈送完畢時會在FB公告；所有禮品贈送完畢時，集點活動即提前結束（以抵達商店現場兌換之順序為準；現場獎品用罄後，即使完成集章亦無法兌換獎品，請集章完成之朋友儘早至人權館商品店兌換）。
                    </li>
                    <li>
                      本活動與店家合作內容僅限於集章活動，店家販售之商品與服務品質，屬其經營管理工作，不含於本活動之合作範疇。
                    </li>
                    <li>
                      本活動保留調整之權利，活動辦法及兌換品項請依本網站即時公告為準。
                    </li>
                  </ol>
                  <h4>(三) 本活動合作店家名單如下：</h4>
                  <ol>
                    <li>
                      <strong>トラ偷懶-綠島店</strong> - 綠島鄉南寮村142-2號
                    </li>
                    <li>
                      <strong>女神嫩仙草</strong> - 綠島鄉南寮村193-1號
                    </li>
                    <li>
                      <strong>閎美小舖綠島花生豆花</strong> - 綠島鄉南寮村171號
                    </li>
                    <li>
                      <strong>美好食光</strong> - 綠島鄉南寮村102-16號
                    </li>
                    <li>
                      <strong>觀音洞伴手禮專賣店</strong> -
                      綠島鄉公館村草山2-1號
                    </li>
                    <li>
                      <strong>飛魚本舖名產專賣店</strong> - 綠島鄉南寮村156-1號
                    </li>
                    <li>
                      <strong>觀音洞藝品店</strong> - 綠島鄉公館村草山2-1號
                    </li>
                    <li>
                      <strong>台灣第一家</strong> - 綠島鄉南寮村105號
                    </li>
                    <li>
                      <strong>派吃所冰店</strong> - 綠島鄉南寮村102-8號
                    </li>
                    <li>
                      <strong>浪人雞蛋燒</strong> - 綠島鄉南寮村121號
                    </li>
                    <li>
                      <strong>阿亮雞排</strong> - 綠島鄉南寮村112號
                    </li>
                    <li>
                      <strong>阿亮滷味</strong> - 綠島鄉南寮村112-1號
                    </li>
                    <li>
                      <strong>IM here我在這裡（愛玉仙草冷飲店）</strong> -
                      綠島鄉公館村柴口180-2號
                    </li>
                    <li>
                      <strong>See Sea Toast(造型熱壓吐司店）</strong> -
                      綠島鄉公館村柴口180-2號
                    </li>
                    <li>
                      <strong>二遊_愛玉_aiyu</strong> - 綠島鄉公館村柴口61-8號
                    </li>
                    <li>
                      <strong>綠馨小火鍋</strong> - 綠島鄉南寮村漁港5-3號
                    </li>
                    <li>
                      <strong>綠島大街冰館</strong> - 綠島鄉南寮村128號
                    </li>
                    <li>
                      <strong>創意廚房-夏綠地</strong> - 綠島鄉南寮村103-1號
                    </li>
                    <li>
                      <strong>綠生活海草冰品</strong> - 綠島鄉南寮村150號
                    </li>
                    <li>
                      <strong>綠島隔壁間餐廳</strong> - 綠島鄉中寮村中寮52-1號
                    </li>
                    <li>
                      <strong>海の那一邊</strong> - 綠島鄉中寮村38-2號
                    </li>
                    <li>
                      <strong>鹿肉林特產行</strong> - 綠島鄉南寮村漁港16-3號
                    </li>
                    <li>
                      <strong>翔記餐廳</strong> - 綠島鄉南寮村191-1號
                    </li>
                    <li>
                      <strong>好燙麻辣燙</strong> - 綠島鄉南寮村149號
                    </li>
                    <li>
                      <strong>阿亮滷味</strong> - 綠島鄉南寮村149號
                    </li>
                    <li>
                      <strong>樂達統祥大飯店</strong> - 綠島鄉中寮村6-6號
                    </li>
                    <li>
                      <strong>綠島小鎮民宿</strong> - 綠島鄉中寮村中寮115-1號
                    </li>
                    <li>
                      <strong>桑尼民宿</strong> - 綠島鄉南寮村236號
                    </li>
                    <li>
                      <strong>放個假旅宿</strong> - 綠島鄉中寮村205號
                    </li>
                    <li>
                      <strong>禾風旅棧</strong> - 綠島鄉中寮村188號
                    </li>
                    <li>
                      <strong>海明威民宿</strong> - 綠島鄉公館村柴口61-30號
                    </li>
                    <li>
                      <strong>綠島9號背包客棧</strong> - 綠島鄉南寮村漁港9-3號
                    </li>
                    <li>
                      <strong>綠邑民宿</strong> - 綠島鄉南寮村漁港5-2號
                    </li>
                    <li>
                      <strong>明月小築</strong> - 綠島鄉南寮村93號
                    </li>
                    <li>
                      <strong>微風民宿</strong> - 綠島鄉公館村柴口58-1號
                    </li>
                    <li>
                      <strong>星海民宿</strong> - 綠島鄉南寮村95號
                    </li>
                    <li>
                      <strong>新研租車有限公司台東分公司</strong> -
                      綠島鄉南寮村漁港2-7號
                    </li>
                  </ol>
                  <p>
                    綠島人權藝術季{" "}
                    <a href="https://www.facebook.com/GIHRAF/" target="_blank">
                      FB 專頁
                    </a>
                  </p>
                  <img src={coupon} alt="coupon" />
                </article>
              </div>
            </div>
          </div>
        </section>

        <Helmet
          title="集點活動 Coupon・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival"
          meta={[
            {
              name: `description`,
              content:
                "集點活動 Coupon・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:title`,
              content:
                "集點活動 Coupon・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:description`,
              content:
                "集點活動 Coupon・假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:type`,
              content: `website`,
            },
            {
              property: `og:image`,
              content: require("../images/og_image.jpg"),
            },
          ]}
        ></Helmet>
      </>
    );
  }
}

export default Page;
